// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/scope_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ControlSetting, InherentRiskSetting } from "./control_service_pb";
import { file_inventory_v1_control_service } from "./control_service_pb";
import type { ConditionsGroup, Scope, ScopeInput } from "./scope_pb";
import { file_inventory_v1_scope } from "./scope_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/scope_service.proto.
 */
export const file_inventory_v1_scope_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_inventory_v1_control_service, file_inventory_v1_scope]);

/**
 * @generated from message inventory.v1.ListScopesRequest
 */
export type ListScopesRequest = Message<"inventory.v1.ListScopesRequest"> & {
};

/**
 * Describes the message inventory.v1.ListScopesRequest.
 * Use `create(ListScopesRequestSchema)` to create a new message.
 */
export const ListScopesRequestSchema: GenMessage<ListScopesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 0);

/**
 * @generated from message inventory.v1.ListScopesResponse
 */
export type ListScopesResponse = Message<"inventory.v1.ListScopesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Scope scopes = 1;
   */
  scopes: Scope[];
};

/**
 * Describes the message inventory.v1.ListScopesResponse.
 * Use `create(ListScopesResponseSchema)` to create a new message.
 */
export const ListScopesResponseSchema: GenMessage<ListScopesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 1);

/**
 * @generated from message inventory.v1.GetScopeRequest
 */
export type GetScopeRequest = Message<"inventory.v1.GetScopeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.GetScopeRequest.
 * Use `create(GetScopeRequestSchema)` to create a new message.
 */
export const GetScopeRequestSchema: GenMessage<GetScopeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 2);

/**
 * @generated from message inventory.v1.ScopeRules
 */
export type ScopeRules = Message<"inventory.v1.ScopeRules"> & {
  /**
   * @generated from field: optional inventory.v1.InherentRiskSetting inherent_risk_setting = 1;
   */
  inherentRiskSetting?: InherentRiskSetting;

  /**
   * @generated from field: repeated inventory.v1.ConditionsGroup conditions_groups = 2;
   */
  conditionsGroups: ConditionsGroup[];
};

/**
 * Describes the message inventory.v1.ScopeRules.
 * Use `create(ScopeRulesSchema)` to create a new message.
 */
export const ScopeRulesSchema: GenMessage<ScopeRules> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 3);

/**
 * @generated from message inventory.v1.GetScopeResponse
 */
export type GetScopeResponse = Message<"inventory.v1.GetScopeResponse"> & {
  /**
   * @generated from field: inventory.v1.Scope scope = 1;
   */
  scope?: Scope;

  /**
   * @generated from field: inventory.v1.ScopeRules scope_rules = 2;
   */
  scopeRules?: ScopeRules;

  /**
   * @generated from field: repeated inventory.v1.ControlSetting controls = 3;
   */
  controls: ControlSetting[];
};

/**
 * Describes the message inventory.v1.GetScopeResponse.
 * Use `create(GetScopeResponseSchema)` to create a new message.
 */
export const GetScopeResponseSchema: GenMessage<GetScopeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 4);

/**
 * @generated from message inventory.v1.CreateScopeRequest
 */
export type CreateScopeRequest = Message<"inventory.v1.CreateScopeRequest"> & {
  /**
   * @generated from field: inventory.v1.ScopeInput scope = 1;
   */
  scope?: ScopeInput;

  /**
   * @generated from field: inventory.v1.ScopeRules scope_rules = 2;
   */
  scopeRules?: ScopeRules;

  /**
   * @generated from field: repeated string control_ids = 3;
   */
  controlIds: string[];
};

/**
 * Describes the message inventory.v1.CreateScopeRequest.
 * Use `create(CreateScopeRequestSchema)` to create a new message.
 */
export const CreateScopeRequestSchema: GenMessage<CreateScopeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 5);

/**
 * @generated from message inventory.v1.CreateScopeResponse
 */
export type CreateScopeResponse = Message<"inventory.v1.CreateScopeResponse"> & {
  /**
   * @generated from field: inventory.v1.Scope scope = 1;
   */
  scope?: Scope;
};

/**
 * Describes the message inventory.v1.CreateScopeResponse.
 * Use `create(CreateScopeResponseSchema)` to create a new message.
 */
export const CreateScopeResponseSchema: GenMessage<CreateScopeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 6);

/**
 * @generated from message inventory.v1.UpdateScopeDefinitionRequest
 */
export type UpdateScopeDefinitionRequest = Message<"inventory.v1.UpdateScopeDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.ScopeInput scope = 2;
   */
  scope?: ScopeInput;

  /**
   * Replace-all: final desired state
   *
   * @generated from field: inventory.v1.ScopeRules scope_rules = 3;
   */
  scopeRules?: ScopeRules;
};

/**
 * Describes the message inventory.v1.UpdateScopeDefinitionRequest.
 * Use `create(UpdateScopeDefinitionRequestSchema)` to create a new message.
 */
export const UpdateScopeDefinitionRequestSchema: GenMessage<UpdateScopeDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 7);

/**
 * @generated from message inventory.v1.UpdateScopeDefinitionResponse
 */
export type UpdateScopeDefinitionResponse = Message<"inventory.v1.UpdateScopeDefinitionResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateScopeDefinitionResponse.
 * Use `create(UpdateScopeDefinitionResponseSchema)` to create a new message.
 */
export const UpdateScopeDefinitionResponseSchema: GenMessage<UpdateScopeDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 8);

/**
 * @generated from message inventory.v1.DeleteScopeRequest
 */
export type DeleteScopeRequest = Message<"inventory.v1.DeleteScopeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.DeleteScopeRequest.
 * Use `create(DeleteScopeRequestSchema)` to create a new message.
 */
export const DeleteScopeRequestSchema: GenMessage<DeleteScopeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 9);

/**
 * @generated from message inventory.v1.DeleteScopeResponse
 */
export type DeleteScopeResponse = Message<"inventory.v1.DeleteScopeResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteScopeResponse.
 * Use `create(DeleteScopeResponseSchema)` to create a new message.
 */
export const DeleteScopeResponseSchema: GenMessage<DeleteScopeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 10);

/**
 * @generated from message inventory.v1.SetScopeControlsRequest
 */
export type SetScopeControlsRequest = Message<"inventory.v1.SetScopeControlsRequest"> & {
  /**
   * @generated from field: string scope_id = 1;
   */
  scopeId: string;

  /**
   * Replace-all: final set of selected controls
   *
   * @generated from field: repeated string control_ids = 2;
   */
  controlIds: string[];
};

/**
 * Describes the message inventory.v1.SetScopeControlsRequest.
 * Use `create(SetScopeControlsRequestSchema)` to create a new message.
 */
export const SetScopeControlsRequestSchema: GenMessage<SetScopeControlsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 11);

/**
 * @generated from message inventory.v1.SetScopeControlsResponse
 */
export type SetScopeControlsResponse = Message<"inventory.v1.SetScopeControlsResponse"> & {
};

/**
 * Describes the message inventory.v1.SetScopeControlsResponse.
 * Use `create(SetScopeControlsResponseSchema)` to create a new message.
 */
export const SetScopeControlsResponseSchema: GenMessage<SetScopeControlsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope_service, 12);

/**
 * @generated from service inventory.v1.ScopeService
 */
export const ScopeService: GenService<{
  /**
   * @generated from rpc inventory.v1.ScopeService.ListScopes
   */
  listScopes: {
    methodKind: "unary";
    input: typeof ListScopesRequestSchema;
    output: typeof ListScopesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ScopeService.GetScope
   */
  getScope: {
    methodKind: "unary";
    input: typeof GetScopeRequestSchema;
    output: typeof GetScopeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ScopeService.CreateScope
   */
  createScope: {
    methodKind: "unary";
    input: typeof CreateScopeRequestSchema;
    output: typeof CreateScopeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ScopeService.UpdateScopeDefinition
   */
  updateScopeDefinition: {
    methodKind: "unary";
    input: typeof UpdateScopeDefinitionRequestSchema;
    output: typeof UpdateScopeDefinitionResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ScopeService.DeleteScope
   */
  deleteScope: {
    methodKind: "unary";
    input: typeof DeleteScopeRequestSchema;
    output: typeof DeleteScopeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ScopeService.SetScopeControls
   */
  setScopeControls: {
    methodKind: "unary";
    input: typeof SetScopeControlsRequestSchema;
    output: typeof SetScopeControlsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_scope_service, 0);

